import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class WindowOpennerService {
    
  constructor(@Inject(DOCUMENT) private document: Document) {}

  openUrlInNewTab(url: string, target: string = '_blank', features: string = 'noopener,noreferrer'): void {
    this.document.defaultView?.open(url, target, features);
  }
}
